<script>
    import { Tooltip } from "sveltestrap";

    export let display = true;
    export let count;
    export let label;
    export let activityName;
    export let activityNamePast;
    export let displayCompact = false;
    export let displayComfortable = false;

    let engagementIcon;
    let engagementTooltip;
    let engagementIconClass;

    $: {
        if (count == 0) {
            engagementIcon = 'x-circle-fill';
            engagementIconClass = 'text-danger';
            engagementTooltip = `No ${activityName}`;
        } else if (count == 1) {
            engagementIcon = '1-circle-fill';
            engagementIconClass = 'text-warning';
            engagementTooltip = `${activityNamePast} on 1 day`;
        } else {
            engagementIcon = 'check-circle-fill';
            engagementIconClass = 'text-success';
            engagementTooltip = `${activityNamePast} on ${count} days`;
        }
    }
</script>

<style>
    .early-days-element {
        display: flex;
        flex: 0 0 50%;
        align-items: center;
        flex-wrap: nowrap;
        margin-top: 3px;
        margin-bottom: 7px;
    }

    .early-days-element span.element-icon {
        font-size: 15px;
        line-height: 15px;
    }

    .early-days-element span.element-name {
        font-size: 10.5px;
        font-weight: 700;
        margin-left: 3px;
    }

    .early-days-element span.element-name.hidden {
        filter: opacity(75%);
        font-weight: 500;
    }

    .early-days-element.compact {
        margin-top: 1px;
        margin-bottom: 4px;
    }

    .early-days-element.comfortable {
        flex: 0 0 100%;
        justify-content: center;
        align-items: flex-start;
        margin-top: 6px;
        margin-bottom: 4px;
    }
</style>

{#if display}
    <div class="early-days-element" id="ed-row-{label}" class:compact={displayCompact} class:comfortable={displayComfortable}>
        <span class="element-icon {engagementIconClass}"><i class="bi bi-{engagementIcon}" /></span>
        <span class="element-name" class:hidden={!count == 0}>{label}</span>
    </div>
    <Tooltip target="ed-row-{label}" placement="bottom">
        {engagementTooltip}
    </Tooltip>
{/if}